import { useContext } from 'react';

import { UserDetailsContext } from './context';

export const useUserDetails = () => {
  return useContext(UserDetailsContext);
};
